import * as XLSX from 'xlsx/dist/xlsx.mini.min';
import {
  Component,
  inject,
  ChangeDetectionStrategy,
  input,
} from '@angular/core';
import { HumanizePipe } from '@app/core/pipes/humanize.pipe';

import { PivotReport, ToolbarComponent } from './toolbar/toolbar.component';
import {
  PivotTableField,
  RawPivotTableComponent,
} from '../raw-pivot-table/raw-pivot-table.component';
import { Ag1ButtonComponent } from '../ag1-button/ag1-button.component';
import { NgTemplateOutlet } from '@angular/common';
import { FieldDrawerComponent } from './field-drawer/field-drawer.component';
import { Ag1LoaderComponent } from '../ag1-loader/ag1-loader.component';

@Component({
  selector: 'ag-pivot-table',
  templateUrl: './pivot-table.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ToolbarComponent,
    Ag1ButtonComponent,
    NgTemplateOutlet,
    FieldDrawerComponent,
    Ag1LoaderComponent,
  ],
})
export class PivotTableComponent extends RawPivotTableComponent {
  private humanizePipe = inject(HumanizePipe);

  readonly possibleFields = input<PivotTableField[]>(undefined);

  readonly configType = input<string>(undefined);

  readonly showFieldToggle = input(true);

  readonly canSaveAsPublic = input(false);

  readonly isLoading = input<boolean>(true);

  showFields = false;

  constructor() {
    super();
  }

  override rePivot(): void {
    this.reRender();
  }

  reRender() {
    super.rePivot();
  }

  handleFieldConfigChange() {
    this.reRender();
  }

  handleConfigClick() {
    this.showFields = !this.showFields;
  }

  handleReportChange(event: PivotReport) {
    this.rows.set(event.rows);
    this.cols.set(event.cols);
    this.values.set(event.values);

    this.reRender();
  }

  // mirrors the v1 cash-flow's export format
  // doesn't actually export the pivoted table, but rather the minimal data set required to make that pivot
  exportExcel(fileName: string) {
    const hsh = {};
    const data = this.data();
    const rows = this.rows();
    const cols = this.cols();
    const values = this.values();

    data.forEach((element) => {
      this.aggregateV2(hsh, element, 0, [...rows, ...cols], values);
    });

    const aggregatedHeaders = [...rows, ...cols, ...values];

    const minimalDataSet = [];

    minimalDataSet.push(aggregatedHeaders.map((h) => h.field));

    data.forEach((originalItem) => {
      const minimalItem = [];

      aggregatedHeaders.forEach((header) => {
        minimalItem.push(originalItem[header.field]);
      });

      minimalDataSet.push(minimalItem);
    });

    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(minimalDataSet);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1');
    XLSX.writeFile(wb, fileName + '-' + new Date().toISOString() + '.xlsx');
  }
}
